import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';

const LogoutContainer = ({
  actions: {
    createSuccessAlert,
    dismissLastAlert,
    logOut,
  },
  user: {
    isLoggedIn,
    isLoggingOut,
  },
  router: { navigate },
}) => {
  const tryLogOut = async () => {
    if (isLoggedIn && !isLoggingOut) {
      await logOut({
        onSucceed: () => { createSuccessAlert(i18n.t('logoutSucceedMsg')); },
      });
    }
  };

  useEffect(() => {
    tryLogOut();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      dismissLastAlert();
      navigate('/login', { trigger: true });
    }, 1000);
    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  return (
    <h3>
      {i18n.t('loggingOut')}
    </h3>
  );
};

LogoutContainer.propTypes = {
  actions: PropTypes.shape({
    createSuccessAlert: PropTypes.func.isRequired,
    dismissLastAlert: PropTypes.func.isRequired,
    logOut: PropTypes.func.isRequired,
  }).isRequired,
  router: PropTypes.shape({
    navigate: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    isLoggedIn: PropTypes.bool.isRequired,
    isLoggingOut: PropTypes.bool.isRequired,
  }).isRequired,
};

LogoutContainer.defaultProps = {};

export default connectActionsAndReducers(LogoutContainer);



// WEBPACK FOOTER //
// ./src/containers/login/LogoutContainer.js